var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{attrs:{"datetime":_vm._f("formatDate")(_vm.date,'YYYY-MM-DD')}},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.date,'DD MMMM YYYY', _vm.language)))])}
var staticRenderFns = []

export { render, staticRenderFns }